import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import appliance from '../../json/appliance-removal-data.json'

const applianceServiceData = {
  name: 'Appliance Removal and Recycling',
  description:
    'Professional appliance disposal and recycling for homes and businesses nationwide. Dimension removes refrigerators, washers, dryers, ovens, and more, recovering metal for recycling.',
  serviceType: 'Appliance Removal',
  url: 'https://getdimension.com/appliance-removal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Refrigerator and Freezer Removal' },
    { name: 'Washer and Dryer Removal' },
    { name: 'Oven, Stove, and Dishwasher Removal' },
    { name: 'Commercial Appliance Removal' },
    { name: 'Appliance Metal Recycling' },
  ],
}

const applianceFAQData = {
  questions: appliance.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function ApplianceRemoval() {
  return (
    <>
      <Head>
        <title>Appliance Removal &amp; Disposal Services | Dimension</title>
        <meta
          name="description"
          content="Professional appliance disposal and recycling nationwide. Dimension removes refrigerators, washers, dryers, and ovens, recovering metal for recycling, with pricing by the unit from around $79."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/appliance-removal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={applianceServiceData} />
        <SchemaMarkup type="FAQPage" data={applianceFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={appliance.pitch.heading}
          material={appliance.pitch.material}
          pitchText={appliance.pitch.pitchText}
          ctaLink={appliance.pitch.ctaLink}
          ctaText={appliance.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...appliance.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...appliance.benefits} />
        <Approach {...appliance.approach} />
        <FAQ {...appliance.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'TV and Electronics Removal',
              href: '/tv-electronics-removal',
              description:
                'Certified e-waste recycling for old TVs, monitors, computers, and electronics.',
            },
            {
              label: 'Furniture Removal',
              href: '/furniture-removal',
              description:
                'Convenient removal of sofas, chairs, desks, and bulky furniture, with donation and recycling first.',
            },
            {
              label: 'Junk Removal',
              href: '/junk-removal',
              description:
                'Full-service junk hauling and whole-home or office cleanouts, priced by volume.',
            },
            {
              label: 'Mattress Removal',
              href: '/mattress-removal',
              description:
                'Cheap mattress and bed-set disposal with recycling of steel, foam, and fiber.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default ApplianceRemoval
